import React, { Component } from 'react';
import { Layout, Collapse, Icon, Table, Row, Col, Form, DatePicker, Input, Select, Button, Spin, Modal, Checkbox, Radio, Upload, Cascader, Tabs, Card, List, Tooltip, Switch } from 'antd';
import { FormattedMessage, useIntl, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { filter, last, find, isNil } from 'lodash';
import './Category.css';
import { toUpperKey } from '../../../../../util/helpper';
import moment from 'moment';
import ScrollToTop from '../../../../../components/ScrollToTop';
import MenuSider from '../../../../../components/MenuSider';
import IntlMessages from '../../../../../util/IntlMessages';
import DateTimeFormat from '../../../../../Constants/DateTimeFormat';
import Local from '../../../../../Constants/Local';
import { Odata_Url, Constants } from '../../../../../Constants/Constants';
import Language from '../../../../../Constants/Language';

const { Panel } = Collapse;
const { Content } = Layout;
const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const { Search, TextArea } = Input;

class Action extends Component {

    constructor(prop) {
        super(prop);

        this.state = {
            responsibleSearchModalVisible: false,
            isResponsibleSearchModalLoading: false,
            responsibleSearchDatas: [],
        }
    }

    componentDidMount() {

    }

    validate = () => {
        const result = {
            isPass: true,
            msg: "",
        };

        const observationTrn = this.props.observationTrn;

        if (this.props.optCategoryUnSafes) {
            this.props.optCategoryUnSafes.forEach(optCategoryUnSafe => {
                if (!optCategoryUnSafe.rootcauseID) {
                    result.isPass = false;
                    result.msg = this.props.intl.formatMessage({ id: 'Action.validate.error.emptyRootCause' });
                }
            });
        }

        if (result.isPass) {
            if (observationTrn.actionType === "forward" && !observationTrn.userResponsible) {
                result.isPass = false;
                result.msg = this.props.intl.formatMessage({ id: 'Action.validate.error.emptyResponsible' });
            }
        }

        return result;
    }

    onCategoryRootCause = (value, category) => {
        category.rootcauseID = value;
        const optRootCauseSelected = find(category.optRootCauses, (optRC) => {
            return optRC.PKRootcauseID === value;
        });
        if (optRootCauseSelected) {
            category.rootCauseData = {
                categoryID: optRootCauseSelected.CategoryID,
                rootcauseEN: optRootCauseSelected.Rootcause_EN,
                rootcauseID: optRootCauseSelected.PKRootcauseID,
                rootcauseTH: optRootCauseSelected.Rootcause,
            };
        }
        
        this.props.setOptCategoryUnSafes(this.props.optCategoryUnSafes);
    }

    onActionTypeChange = (value) => {

        let userResponsible = this.props.observationTrn.userResponsible;
        let userResponsibleData = this.props.observationTrn.userResponsibleData;

        if (value === "doitandcomplete") {
            this.getTokenHeader().then((tokenHeader) => {
                axios.get("api/CTObservationTransactionV2/OptUserResponseByOwnerId?ctUserID=" + this.props.observationTrn.userID, tokenHeader).then(userDataResp => {
                    const userData = userDataResp.data;
                    userResponsible = userData.userId;
                    userResponsibleData = userData;

                    this.props.setObservationTrnFields([
                        {
                            value: value,
                            fieldName: "actionType"
                        },
                        {
                            value: userResponsible,
                            fieldName: "userResponsible"
                        },
                        {
                            value: { ...userResponsibleData },
                            fieldName: "userResponsibleData"
                        },
                    ]);
                });
            });
        }
        else if (value === "doit") {
            this.getTokenHeader().then((tokenHeader) => {
                axios.get("api/CTObservationTransactionV2/OptUserResponseByOwnerId?ctUserID=" + this.props.observationTrn.userID, tokenHeader).then(userDataResp => {
                    const userData = userDataResp.data;
                    userResponsible = userData.userId;
                    userResponsibleData = userData;

                    this.props.setObservationTrnFields([
                        {
                            value: value,
                            fieldName: "actionType"
                        },
                        {
                            value: userResponsible,
                            fieldName: "userResponsible"
                        },
                        {
                            value: { ...userResponsibleData },
                            fieldName: "userResponsibleData"
                        },
                    ]);
                });
            });
        }
        else if (value === "forward") {
            userResponsible = undefined;
            userResponsibleData = undefined;

            this.props.setObservationTrnFields([
                {
                    value: value,
                    fieldName: "actionType"
                },
                {
                    value: userResponsible,
                    fieldName: "userResponsible"
                },
                {
                    value: { ...userResponsibleData },
                    fieldName: "userResponsibleData"
                },
            ]);
        }
        else {
            userResponsible = undefined;
            userResponsibleData = undefined;

            this.props.setObservationTrnFields([
                {
                    value: value,
                    fieldName: "actionType"
                },
                {
                    value: userResponsible,
                    fieldName: "userResponsible"
                },
                {
                    value: { ...userResponsibleData },
                    fieldName: "userResponsibleData"
                },
            ]);
        }
    }

    openResponsibleSearchModal = () => {
        this.setState({
            responsibleSearchModalVisible: true,
        });
    }

    onResponsibleSearchSelect = (selectedUser) => {
        this.props.setObservationTrnFields([
            {
                value: selectedUser.userId,
                fieldName: "userResponsible"
            },
            {
                value: { ...selectedUser },
                fieldName: "userResponsibleData"
            },
        ]);

        this.setState({
            responsibleSearchModalVisible: false,
        });
    }

    onResponsibleSearchCancel = () => {
        this.setState({
            responsibleSearchModalVisible: false,
        });
    }

    onResponsibleSearchData = (keyword) => {
        this.setState({ isResponsibleSearchModalLoading: true }, () => {
            this.getTokenHeader().then((tokenHeader) => {

                let lang = Language.TH;
                if (this.props.intl.locale === Local.EN) {
                    lang = Language.EN;
                }

                axios.get("api/CTObservationTransactionV2/OptUserResponseSearch?keyword=" + keyword + "&lang=" + lang + "&companyID=" + this.props.observationTrn.companyID, tokenHeader).then(userDataResp => {
                    this.setState({
                        isResponsibleSearchModalLoading: false,
                        responsibleSearchDatas: userDataResp.data
                    });
                });
            });
        });
    }

    getTokenHeader = () => {
        var $getToken = new Promise((resolve, reject) => {
            axios.get('auth/token').then((res) => {
                const tokenHeader = { headers: { "Authorization": "Bearer " + res.data } };
                resolve(tokenHeader);
            }).catch(err => {
                if (401 === err.response.status) {
                    localStorage.setItem("ObsReqRedirectAfterLogin", "ObsReqRedirectAfterLogin");
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const isReadonly = this.props.isReadonly;
        const validated = this.props ? this.props.validated : false;
        const local = this.props.intl ? this.props.intl.locale : Local.TH;
        const optCategoryUnSafes = this.props.optCategoryUnSafes ? this.props.optCategoryUnSafes : [];
        const observationTrn = this.props.observationTrn ? this.props.observationTrn : {};

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
                lg: { span: 2 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
                lg: { span: 20 }
            },
        };

        const sortText = (aText, bText) => {
            if (aText === bText) return 0
            else if (isNil(aText)) return 1
            else if (isNil(bText)) return -1
            else
                return aText.toLowerCase().localeCompare(bText.toLowerCase())
        }

        var userResponseName = "";
        if (observationTrn && observationTrn.userResponsibleData && observationTrn.userResponsibleData.userId) {
            if (local === Local.EN) {
                userResponseName = observationTrn.userResponsibleData.fullNameEN;
            }
            else {
                userResponseName = observationTrn.userResponsibleData.fullNameTH;
            }
        }

        return (
            <Card size="small">
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <IntlMessages id="Action.job_observed" />&nbsp;&nbsp;
                {this.props.isUnsafe ? (<>
                            <Button size="default" type="link" className="subcate-btn-unsafe">Unsafe</Button>
                        </>) : (<>
                            <Button size="default" type="link" className="subcate-btn-safe">Safe</Button>
                        </>)}
                    </Col>
                </Row>
                <br />
                {
                    this.props.isUnsafe ? (<>
                        {optCategoryUnSafes.map(optCategoryUnSafe => {
                            return (<>
                                <Card size="small">
                                    <Row>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <img src={"images/" + optCategoryUnSafe.Image_name} style={{ width: "40px", filter: "grayscale(100%)" }} />&nbsp;&nbsp;
                                        <span>{local === Local.TH ? optCategoryUnSafe.Category_Name : optCategoryUnSafe.Category_Name_EN}</span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item {...formItemLayout} label={<IntlMessages id="Action.rootcause" />}
                                                validateStatus={validated && !optCategoryUnSafe.rootcauseID ? "error" : "success"}
                                            >
                                                <Select
                                                    disabled={isReadonly}
                                                    allowClear={true}
                                                    style={{ width: '100%' }}
                                                    placeholder="Please select"
                                                    value={optCategoryUnSafe.rootcauseID}
                                                    onChange={(value) => { this.onCategoryRootCause(value, optCategoryUnSafe) }}
                                                >
                                                    {optCategoryUnSafe.optRootCauses.map(optRootCause => {
                                                        return <Option key={optRootCause.PKRootcauseID} value={optRootCause.PKRootcauseID}>{local === Local.TH ? optRootCause.Rootcause : optRootCause.Rootcause_EN}</Option>
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                                <br />
                            </>);
                        })}
                        <br />
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Tooltip placement="top" title="Inform this is near miss (the unplanned event that has the potential to cause human injury, environmental or equiptment damage)">
                                    <Icon type="info-circle" />&nbsp;&nbsp;<IntlMessages id="Action.near_miss" />?
                                </Tooltip>&nbsp;&nbsp;
                                <Switch disabled={isReadonly} checked={observationTrn.nearmiss} onChange={(checked) => { this.props.setObservationTrnField(checked, "nearmiss"); }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={<IntlMessages id="Action.next_action" />}>
                                    <TextArea rows={3}
                                        disabled={isReadonly}
                                        value={observationTrn.unsafe_detail_next_action} onChange={(e) => { this.props.setObservationTrnField(e.target.value, "unsafe_detail_next_action"); }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={<IntlMessages id="Action.observation_type" />}>
                                    <Select
                                        disabled={isReadonly}
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        placeholder="Please select"
                                        value={observationTrn.actionType}
                                        onChange={(value) => this.onActionTypeChange(value)}
                                    >
                                        <Option value="doitandcomplete"><IntlMessages id='doitandcomplete' /></Option>
                                        <Option value="doit"><IntlMessages id='doit' /></Option>
                                        <Option value="forward"><IntlMessages id='forward' /></Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={<IntlMessages id="Action.observation_responsible" />}
                                    validateStatus={validated && observationTrn.actionType === "forward" && !userResponseName ? "error" : "success"}
                                >
                                    {observationTrn.actionType === "forward" ? (
                                        <Search placeholder={"No selected value."} enterButton
                                            readOnly={true}
                                            value={userResponseName}
                                            onSearch={this.openResponsibleSearchModal}
                                            disabled={isReadonly}
                                        />
                                    ) : (
                                        <Input value={userResponseName} readOnly={true} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </>) :
                        (<>
                            <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item label={<IntlMessages id="Action.current_safe" />}>
                                        <TextArea rows={3} value={observationTrn.safe_detail} onChange={(e) => { this.props.setObservationTrnField(e.target.value, "safe_detail"); }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <br />
                        </>)
                }
                <Modal
                    width="90%"
                    title="เลือกผู้รับผิดชอบ"
                    visible={this.state.responsibleSearchModalVisible}
                    footer={null}
                    onCancel={this.onResponsibleSearchCancel}
                >
                    <Spin spinning={this.state.isResponsibleSearchModalLoading}>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Search placeholder="Name/E-Mail" enterButton onSearch={this.onResponsibleSearchData} />
                            </Col>
                        </Row>
                        <br />
                        <Table dataSource={this.state.responsibleSearchDatas}
                            size="small"
                            bordered={true}
                            pagination={{ pageSize: 10 }}
                            rowKey="userId">
                            <Column dataIndex="userId" title="" align="center"
                                render={(text, record) => {
                                    return <>
                                        <Button size="small" onClick={() => { this.onResponsibleSearchSelect(record); }}><Icon type="select" /> Select</Button>
                                    </>
                                }}
                            />
                            <Column dataIndex="fullNameTH" title="ชื่อ" align="center"
                                sorter={(a, b) => sortText(a.fullNameTH, b.fullNameTH)}
                            />
                            <Column dataIndex="fullNameEN" title="Name" align="center"
                                sorter={(a, b) => sortText(a.fullNameEN, b.fullNameEN)}
                            />
                            <Column dataIndex="company" title="Company" align="left"
                                sorter={(a, b) => sortText(a.company, b.company)}
                            />
                            <Column dataIndex="department" title="Department" align="left"
                                sorter={(a, b) => sortText(a.department, b.department)}
                            />
                            <Column dataIndex="division" title="Division" align="left"
                                sorter={(a, b) => sortText(a.division, b.division)}
                            />
                            <Column dataIndex="email" title="E-Mail" align="left"
                                sorter={(a, b) => sortText(a.email, b.email)}
                            />
                        </Table>
                    </Spin>
                </Modal>
            </Card>
            );
    }

}

export default injectIntl(Action, { withRef: true });